module.exports = __webpack_public_path__ + "static/media/apple.f2d0d335.png";